import { Component, Input } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../services";
import { TpvTicketShowListDetailsPage } from '../tpv-ticket-show-list-details/tpv-ticket-show-list-details';
import { TipsPage } from '../../../../components/popups/tips/tips';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Component para la generacion de la lista agrupada de tickets en el tpv ademas de su opcion
 * de count, no count y delete
 */

@Component({
  selector: 'page-tpv-ticket-selected-list-ticket',
  templateUrl: 'tpv-ticket-selected-list-ticket.html',
})
export class TpvTicketSelectedListTicketPage {
  @Input() selected_list: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public tpvServices: TPVServices,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public translate: TranslateService,
    public toastCtrl: ToastController) { }

  deleteTableList(valueSearch) {
    this.tpvServices.deleteTableList(valueSearch);
  }

  showOrdersDetails() {
    if (this.globals.checkLimitsByLicense('tpv', 'complete_order')) {
      this.navCtrl.push(TpvTicketShowListDetailsPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  addTip() {
    let profileModal = this.modalCtrl.create(TipsPage, { origin: 'tpv' });
    profileModal.present();
  }

  deleteTip() {
    this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.tip = 0;
    var uid = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID;

    this.tpvServices.afs.collection('tables').doc(uid).update({
      ticket: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket
    });
  }

  setNameInBox(value) {
    this.tpvServices.deleteKeyboard();
    this.tpvServices._name = value.name;
    this.tpvServices._price = value.price;
    this.tpvServices._delete = value.delete;
    this.tpvServices._count = value.count;
    this.tpvServices._type = value.type;
    this.tpvServices._uid = value.uid_element;

    this.tpvServices.k_screen = value.name;
    this.tpvServices.keyboard_screen = this.tpvServices.k_screen;
  }

  openSendOrder() {
    if (this.globals.checkLimitsByLicense('tpv', 'send_kitchen')) {
      const confirm = this.alertCtrl.create({
        title: this.translate.instant('instant-enviar-comanda'),
        message: this.translate.instant('instant-seguro-enviar-comanda-cocina'),
        buttons: [
          {
            text: this.translate.instant('general-no'),
            handler: () => {

            }
          },
          {
            text: this.translate.instant('general-si'),
            handler: () => {
              this.sendOrder();
            }
          }
        ]
      });
      confirm.present();
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async sendOrder() {
    var today = new Date();
    var _order_tmp = [];
    var _list = [];
    for (let element of this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list)) {
      var obj = {};
      if (element.tags == undefined) {
        element.tags = [];
      }
      obj = {
        name: element.name,
        change: '',
        finish: '',
        state: 'normal',
        variations: this.arrayEmpty(element.variation),
        person: this.ifPersonEmpty(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].person),
        tags: element.tags,
        uid_element: element.uid_element
      }
      _list.push(obj);

    }

    var _oder = {
      name: this.translate.instant('general-todos'),
      list: _list,
      only_combo: false,
    }
    _order_tmp.push(_oder);

    //get customer
    var _customer = []
    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer) {
      _customer = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer;
    }

    await this.tpvServices.afs.collection('orders').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'date': today,
      'hour': moment(today).format("HH:mm"),
      'sections': _order_tmp,
      'show_kitchen': true,
      'show_order': true,
      'table': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name,
      'table_uid': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID,
      'type': 'table',
      'waiter': this.globals.waiter,
      'waiter_uid': this.globals.waiter_uid,
      'created_at': new Date(),
      'updated_at': new Date(),
      'notes': '',
      'datetime_pickup_delivey': new Date(),
      'customer': _customer,
    }).then(doc => {
      //toast enviado a cocina
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-comanda-enviada'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    });
  }

  ifPersonEmpty(person) {
    if (person != undefined) {
      return person;
    } else {
      return '';
    }
  }


  arrayEmpty(arr) {
    if (arr != undefined) {
      return arr;
    } else {
      return {};
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket/tpv-ticket-selected-list-ticket.ts